[
  {
    "type": 6283,
    "variant": "slope-lower",
    "name": "Railway slope: ground to half-level",
    "height": 0,
    "rise": 0.125,
    "curved": false,
    "structure": "slope"
  },
  {
    "type": 6284,
    "variant": "slope-upper",
    "name": "Railway slope: half-level to level 1",
    "height": 0.125,
    "rise": 0.125,
    "curved": false,
    "structure": "slope"
  },
  {
    "type": 6285,
    "variant": "slope-high-lower",
    "name": "Railway slope: level 1 to one-and-a-half",
    "height": 0.25,
    "rise": 0.125,
    "curved": false,
    "structure": "slope"
  },
  {
    "type": 6286,
    "variant": "slope-high-upper",
    "name": "Railway slope: one-and-a-half to level 2",
    "height": 0.375,
    "rise": 0.125,
    "curved": false,
    "structure": "slope"
  },
  {
    "type": 6287,
    "variant": "platform",
    "name": "Raised railway: level 1",
    "height": 0.25,
    "rise": 0,
    "curved": false,
    "structure": "platform"
  },
  {
    "type": 6288,
    "variant": "platform-high",
    "name": "Raised railway: level 2",
    "height": 0.5,
    "rise": 0,
    "curved": false,
    "structure": "platform"
  },
  {
    "type": 6289,
    "variant": "curve-raised",
    "name": "Raised railway curve: level 1",
    "height": 0.25,
    "rise": 0,
    "curved": true,
    "structure": "platform"
  },
  {
    "type": 6290,
    "variant": "curve-high",
    "name": "Raised railway curve: level 2",
    "height": 0.5,
    "rise": 0,
    "curved": true,
    "structure": "platform"
  },
  {
    "type": 6291,
    "variant": "bridge-timber",
    "name": "Timber trestle railway bridge",
    "height": 0.25,
    "rise": 0,
    "curved": false,
    "structure": "timber"
  },
  {
    "type": 6292,
    "variant": "bridge-stone",
    "name": "Stone arch railway bridge",
    "height": 0.5,
    "rise": 0,
    "curved": false,
    "structure": "stone"
  },
  {
    "type": 6293,
    "variant": "bridge-steel",
    "name": "Steel truss railway bridge",
    "height": 0.5,
    "rise": 0,
    "curved": false,
    "structure": "steel"
  }
]
